import { FC, memo } from 'react';
import type { EventProps } from 'react-big-calendar';
import type {
  CalendarAppointmentEvent,
  CalendarAvailabilityEvent
} from '../../../Calendar/Calendar.types';
import { DAY_AVAILABILITIES } from '../../../AppointmentForm/AppointmentForm.consts';
import { AvailabilityBackgroundContainer } from './CalendarAppointment.styles';
import AvailabilityEvent from '../AvailabilityEvent/AvailabilityEvent';
import { CalendarAppointment } from './CalendarAppointment';

/**
 * This routing layer is meant to prevent background events using the heavy
 * CalendarAppointment component and the many store/hook subscriptions.
 */

const areEventPropsEqual = (
  prevProps: EventProps<CalendarAppointmentEvent>,
  nextProps: EventProps<CalendarAppointmentEvent>
) => prevProps.event === nextProps.event;

const CalendarEventRouter: FC<EventProps<CalendarAppointmentEvent>> = memo(
  (props) => {
    const { availabilityType, resourceId } = props.event;

    if (resourceId === DAY_AVAILABILITIES) {
      return (
        <AvailabilityEvent
          event={props.event as unknown as CalendarAvailabilityEvent}
        />
      );
    }

    if (availabilityType) {
      return <AvailabilityBackgroundContainer type={availabilityType} />;
    }

    return <CalendarAppointment {...props} />;
  },
  areEventPropsEqual
);

export { CalendarEventRouter };
